import React, {useContext, useEffect, useRef, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "../root/Login";
import {Button, Card, ConfigProvider, Popconfirm, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiInfoCircle, BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import PlantillaLista from "../PlantillaLista";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import dayjs, {Dayjs} from 'dayjs';
import {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import Activitat from "../../model/multilleure/casals/Activitat";
import ActivitatsModal from "./components/ActivitatsModal";
import {GetActivitatsJson} from "../../dao/multilleure/GetActivitatsJson";
import locale from "antd/es/locale/es_ES";
import {Tour, TourProps} from "antd-v5";

const Activitats = () => {
    const titol: string = "ACTIVITATS";
    const nomPermis: string = "Activitats";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Activitat[]>([]);
    const [elementSelected, setElementSelected] = useState<Activitat>(new Activitat());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());

    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetActivitatsJson(page);
        
        if (Array.isArray(dades)) {
            setDades(dades);
            setNameFilters(dades);
        } else {
            console.error("GetActivitatsJson no devolvió un array:", dades);
            setDades([]);
            setNameFilters([]);
        }
        handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        //await DeleteIngredient(id, page);
        await checkDades();
    }

    function afegirElement(element: Activitat) {
        setNouElement(!nouElement);
        setEditar(true);
        setElementSelected(element);
    }

    function togleNouElement(element: Activitat, edit : boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        const nElement: Activitat = {
            ...element,
            any: dayjs(element.any),
            dataDescompte: dayjs(element.dataDescompte),
            alta: dayjs(element.alta)
        };
        setElementSelected(nElement);
    }

    function handleCloseModal() {
        setNouElement(false);
        checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Activitat[]) {
        const ingredientNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(ingredientNames);

        const tipusNames = elements.reduce<Set<string>>((uniqueNames, element) => {
            if (!uniqueNames.has(element.estat)) {
                uniqueNames.add(element.estat);
            }
            return uniqueNames;
        }, new Set());

        const tipusOptions: { text: string; value: string; }[] = Array.from(tipusNames).map(name => ({
            text: name,
            value: name,
        }));

        setTipusFiltres(tipusOptions);
    }

    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/

    const columns: ColumnsType<Activitat> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            sortOrder: 'descend',
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: 30,
            filterSearch: true,
            filters: tipusFiltres,
            render: (estat, ele) => (
                <>
                    <Tag color={"success"}>{ele.estat}</Tag>
                </>
            ),
        },
        {
            key: 'tipus',
            title: 'Tipus',
            dataIndex: 'tipus',
            width: 30,
            filterSearch: true,
            filters: tipusFiltres,
            render: (estat, ele) => (
                 <>
                    {ele.tipus.toLowerCase() === 'casal' && (
                        <Tag color={Colors.colors.color4}>CASAL</Tag>
                    )}
                    {ele.tipus.toLowerCase() === 'extraescolar' && (
                        <Tag color='#A5B5C8'>EXTRAESCOLARS</Tag>
                    )}
                    {ele.tipus.toLowerCase() === 'menjador' && (
                        <Tag color='#FBE096'>MENJADOR</Tag>
                    )}
                    {ele.tipus.toLowerCase() === '0' && (
                        <Tag>Sense tipus</Tag>
                    )}
                </>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele, true)}><BiPencil/></Button>
                            {" "}
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElement(ele.id)}
                                icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                            >
                                <Button title={"Eliminar"}
                                        style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>
                            {" "}
                        </>
                    )}
                    <Button title={"Mostrar"} onClick={() => togleNouElement(ele, false)}
                            style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<Activitat> = {
        loading
    };

    const onChange: TableProps<Activitat>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Activitat) => {
        return (
            <PlantillaLista element={ele}/>
        );
    };

    async function handleDownload(id: string) {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);
    const ref6 = useRef(null);
    const ref7 = useRef(null);
    const ref8 = useRef(null);
    const steps: TourProps['steps'] = [
        {
            title: 'Crear Activitat',
            description: 'Al premer el botó de "nova activitat" s\'obre aquesta pantalla',
            target: () => ref1.current,
        },
        {
            title: 'Dades de l\'Activitat',
            description: 'Omple les dades de l\Activitat.',
            target: () => ref2.current,
        },
        {
            title: 'Preu Rebut',
            description: 'Aquest Preu Rebut es només per marcar un preu comú. De moment el deixes a 0€',
            target: () => ref3.current,
        },
        {
            title: 'Email d\'enviament',
            description: 'Aquest correu es el que apareix quan s\'envia un correu a les families. IMPORTANT: El correu ha d\'estar previament validat per poder enviar correus, només apareixen com a opció els correus validats!!!',
            target: () => ref4?.current
        },
        {
            title: 'Descompte anticipat',
            description: 'Aquesta data es fins a quan conté descompte les incripcions.',
            target: () => ref5.current,
        },
        {
            title: 'Documentació Requerida',
            description: 'Especifica quins documents cal que pujin a la inscripció: Tarjeta sanitaria, Dni, etc...',
            target: () => ref6.current,
        },
        {
            title: 'Correu electrònic',
            description: 'Si es vol posar alguna cosa adicional als correus de les families quan formalitzen una inscripció, cal fer-ho aquí.',
            target: () => ref7.current,
        },
        {
            title: 'Descàrrega de documents',
            description: 'Per poder penja els documents que les families han de descarregar, signar i tornar a pujar a l\inscripció, primer guarda l\'activitat i torna a editar-la.',
            target: () => ref8.current,
            onFinish: () => {
                afegirElement(new Activitat());
                setOpen(false);
            }
        },
    ];

    function tour(b: boolean) {
        afegirElement(new Activitat());
        setOpen(b);
    }

    if (isLoggedIn) {
        return (
            <ConfigProvider locale={locale}>
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {permisosEdicio &&
                                <Button title={"Crear"} ref={ref1} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(new Activitat())}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                            <Button title={"Informació"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                                tour(true)}><BiInfoCircle/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        <Tour open={open} onClose={() => setOpen(false)} steps={steps} />

                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                /*expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}*/
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={"PLANTILLA"} pagina={page}/>
                    {nouElement && (
                        <ActivitatsModal element={elementSelected} onClose={handleCloseModal} visible={nouElement} editar={editar}
                            ref1={ref1} ref2={ref2} ref3={ref3} ref4={ref4} ref5={ref5} ref6={ref6} ref7={ref7} ref8={ref8}
                        />
                    )}
                </div>
            </div>
            </ConfigProvider>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Activitats;
